const PageLoader = () => (
  <div className="h-screen flex items-center justify-center">
    <i className="fa-solid fa-spinner animate-spin mr-2"></i> Loading ...
  </div>
);
export default PageLoader